// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__HjFl2","bgWhite":"Header_bgWhite__l_5w2","hidden":"Header_hidden__GeOVx"};